import { useEffect, useState } from 'react';
import { Shield, RefreshCw, History } from 'lucide-react';
import api from '@/lib/api';
import { toast } from 'sonner';

export default function AdminAudit() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/admin/audit', { params: { limit: 250 } });
      setEvents(data.events || []);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not load audit history');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="admin-page">
      <div className="admin-page-head">
        <div>
          <div className="admin-eyebrow"><Shield size={13} /> Security audit</div>
          <h1>Audit history</h1>
          <p>Account creation, credential rotation and other administrative changes are recorded here.</p>
        </div>
        <button className="admin-lux-button secondary" onClick={load} disabled={loading}>
          <RefreshCw size={16} className={loading ? 'animate-spin' : ''} /> Refresh
        </button>
      </div>

      <div className="admin-card">
        <div className="admin-card-head">
          <div><h2>Administrative events</h2><p>{events.length} recorded events</p></div>
        </div>
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead><tr><th>When</th><th>Actor</th><th>Action</th><th>Target</th><th>Details</th></tr></thead>
            <tbody>
              {events.map((event) => (
                <tr key={event.id}>
                  <td>{event.created_at ? new Date(event.created_at).toLocaleString() : '—'}</td>
                  <td><strong>{event.admin_username || event.admin_id || '—'}</strong></td>
                  <td><span className="admin-status neutral"><History size={10} /> {event.action || 'event'}</span></td>
                  <td>{event.target_id || '—'}</td>
                  <td><code className="text-[10px] break-all">{JSON.stringify(event.details || {})}</code></td>
                </tr>
              ))}
              {!loading && events.length === 0 && (
                <tr><td colSpan="5"><div className="admin-empty">No audit events yet.</div></td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
